import { Container } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useContext } from 'react';
import { Page } from 'components';
import { userContext, userSchema } from './UserContext';
import { UserForm } from './components';


let NewTicket = () => {
    let { isLoading, user, saveUser } = useContext(userContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="User and Permission"
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={userSchema}
                    initialValues={user}
                    onSubmit={(values, action) => {
                        saveUser(values as any);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <UserForm />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default NewTicket;